export const reasonOptions = [
  { id: 'cross-check', value: 'cross-check', label: 'To cross check data with customer' },
  {
    id: 'show-proof',
    value: 'show-proof',
    label: 'To show proof or cross-check data with the customers'
  },
  { id: 'validate-info', value: 'validate-info', label: 'To validate customer information' }
];

export const piiAcknowledgmentText = {
  header: 'Please confirm your acknowledgment',
  disclaimer:
    "By proceeding, I confirm that I am accessing the customer's personal information strictly for the purposes of loan monitoring and loan collection. I understand that my access will be logged and will remain valid only until 7:00 PM today.",
  reasonTitle: 'Select reason for accessing PII'
};

export const operativeHoursText = {
  header: "You cannot access customer's personal information outside of operative hours"
};
